export default "__VITE_ASSET__CyzFujEa__"